<template>
  <div role="tabpanel"
       class="tab-pane"
       :class="[classes]"
       :id="id"
       v-if="showComponent"
       :title="qaAble ? showIfHasPermission?.toString() : null"
       :key="componentRefresh"
  >
    <slot/>
  </div>
</template>

<script>
import checkPermissions from '../../../mixins/checkPermissions';

export default {
  name: "ks-tab-content",
  mixins: [checkPermissions],
  props: {
    classes: {
      type: String,
      default: null
    },
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },
}
</script>
